import { render, staticRenderFns } from "./NotInAllowedRoles.vue?vue&type=template&id=1dfe8c23&scoped=true"
import script from "./NotInAllowedRoles.vue?vue&type=script&lang=js"
export * from "./NotInAllowedRoles.vue?vue&type=script&lang=js"
import style0 from "./NotInAllowedRoles.vue?vue&type=style&index=0&id=1dfe8c23&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfe8c23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dfe8c23')) {
      api.createRecord('1dfe8c23', component.options)
    } else {
      api.reload('1dfe8c23', component.options)
    }
    module.hot.accept("./NotInAllowedRoles.vue?vue&type=template&id=1dfe8c23&scoped=true", function () {
      api.rerender('1dfe8c23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NotInAllowedRoles.vue"
export default component.exports